import { faArrowsSpin, faCopy } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { useAtom } from 'jotai';
import { useState } from 'react';

import { deviceTokenAtom } from '@/features/DeviceCreate/DeviceCreate.store';
import useStyles from '@/pages/Administration/Devices/DeviceDetails/ViewToken/ViewToken.styles';

import useDeviceToken from '../../useDeviceToken';
import type { ViewTokenProps } from '../DeviceCard/DeviceCard.types';

/**
 * Displays and manages device activation token actions.
 *
 * @param props Component properties.
 * @returns Activation token section.
 */
const ViewToken = (props: ViewTokenProps) => {
  const { classes } = useStyles();
  const { items } = props;
  const [tokens] = useAtom<{ [key: string]: string }>(deviceTokenAtom);
  const { refetch, isFetching } = useDeviceToken(items?.device_uid || '');
  const [showInfo, setShowInfo] = useState(false);
  const selectedToken = tokens[items?.device_uid || ''] || '';

  const handleRegenerateToken = () => {
    refetch();
    setShowInfo(true);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(selectedToken);
  };

  return (
    <>
      <Box className={classes.KVFlex}>
        <Box style={{ flex: 0.4 }}>Activation Code</Box>

        {isFetching && <CircularProgress size={16} />}
        {!isFetching && (
          <Box className={classes.dFlex}>
            <span className={classes.token}>
              {selectedToken || 'No token generated'}
            </span>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleCopy}
              sx={{ marginRight: '.5rem' }}
            >
              <FontAwesomeIcon icon={faCopy} size="lg" />
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleRegenerateToken}
            >
              <FontAwesomeIcon icon={faArrowsSpin} size="lg" />
            </Button>
          </Box>
        )}
      </Box>
      {showInfo && (
        <Alert style={{ marginBottom: '.5rem' }} severity="info">
          <Typography>
            Activation tokens can only be used once and expire after 24 hours.
          </Typography>
        </Alert>
      )}
    </>
  );
};

export default ViewToken;
